export enum Tag {
  COMMUNITY = 'COMMUNITY',
  KINDO = 'KINDO'
}
